import axios from "axios";
import { post, put, get, del } from '../api/axioshHttp'

// 获取分组列表
export const getimgGroup = params => {
    return get("/admin/category", params);
};

// 获取图片
export const getimgList = params => {
    return get("/admin/attachment", params);
};

// 删除图片
export const deleteImg = params => {
    return del(`/admin/attachment/${params}`);
};

// 添加分组
export const addGroup = params => {
    return post("/admin/category", params);
};

// 删除分组
export const deleteGroup = params => {
    return del(`/admin/category/${params}`);
};

// 移动分组
export const overGroup = params => {
    return post("/admin/moveAttachment", params);
};


// WEBPACK FOOTER //
// ./src/api/homePage.js